import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal'
import { Button } from 'react-bootstrap';
import utils, { statuses } from './Utils';
import ReCAPTCHA from "react-google-recaptcha";

class RequestReviewModal extends React.Component {
   
    constructor(props) {
        super(props);
        this.state = {
            showModel2: false, userEmail: "", validation: false,verified:false, humanKey:"",
            resultMessage: {
                show: false,
                type: 'error',
                message: ''
            }
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);    
    }
     
    handleClose = () => {        
        this.setState({ showModel2: false, userEmail: "", validation: false , verified: false, humanKey:""});
    }

    callback = (result, message) => {
        if (result) {
            this.setState({
                resultMessage: {
                    show: true,
                    type: 'success',
                    message: 'Your request has received successfully!'
                }
            })
        } else {
            this.setState({
                resultMessage: {
                    show: true,
                    type: 'error',
                    message: 'An error occured! ' + message
                }
            })
        }
        setTimeout(() => {
            this.setState({ 
                showModel2: false,
                resultMessage: {
                    show: false,
                    type: 'error',
                    message: ''
                }
            });
        }, 3000)
    };
 
    handleSend = () => {  
 
        if(this.state?.humanKey === "")
        {
            this.setState({ showModel2: true, validation: false });
            return;
        }              
        var emailValid = this.state?.userEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (emailValid != null) {
            utils.sendRequestMail("expertReview", this.props?.reportId ,this.state?.userEmail,this.state?.humanKey, "", this.callback)
        }
        else {
            this.setState({ validation: true, validationText: "No error." });
        }                    
    }
    handleChange(event) {
        this.setState({ userEmail: event.target.value })
    }
    handleShow = () => {
        this.setState({ showModel2: true,validation:false, humanKey:"" });
    }
    onChange = (value) => {
        this.setState({
            verified: true,
            humanKey:value
          });     
      }
    render() {

        return (
            <>
                <Button variant="primary" onClick={this.handleShow} className="result-op-btn">
                    Request Expert Review
                </Button>

                <Modal show={this.state.showModel2} onHide={this.handleClose} animation={false}>
                    <Modal.Header>
                        <Modal.Title>Request Expert Review</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        If you want the content to be review, send us your request

                        {this.state?.validation ?
                            <div className="alert alert-warning" role="alert">Please enter a valid email address.</div> : <br></br>
                        }
                        {this.state?.resultMessage?.show ?
                            <div className={this.state.resultMessage.type === "error" ? "alert alert-danger" : "alert alert-success"} role="alert">{this.state.resultMessage.message}</div> : <br></br>
                        }
                        <div className="input-group">
                            <span className="input-group-addon" id="basic-addon1">@</span>
                            <input type="email" className="form-control" placeholder="Your email adress" aria-describedby="basic-addon1" onChange={this.handleChange}/>                            
                        </div>
                        <br/>
                        <ReCAPTCHA
                            sitekey="6LdZF_kZAAAAAKenBYd_UtgVL5E75vAoXsDEKkrS"
                            onChange={this.onChange}
                            size="normal"                                
                        />
                    </Modal.Body>                        
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.handleClose} size="sm">
                                Close
                        </Button>
                            <Button variant="primary" onClick={this.handleSend} size="sm">
                                Send
                        </Button>
                        </Modal.Footer>
                </Modal>
            </>
        );
    }
}
export default RequestReviewModal;
